/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createStore, createApi, createEffect, sample } from 'effector';

import { getForbiddenSecurities } from '../api';
import { ApiDataResponse } from '../api/types/response';
import { SecurityInfo } from '../types/marketSchedule';

export const forbidden$ = createStore<SecurityInfo[]>([]);

const helper = createApi(forbidden$, {
  // @ts-ignore
  set: (state, { result }) => {
    if (result && result.success && result.result !== undefined) return result.result;

    return state;
  },
  // @ts-ignore
  update: (state, securities: SecurityInfo[]) => {
    if (securities) {
      return securities;
    }

    return state;
  },
});

export const forbiddenApi = {
  get: createEffect<{}, ApiDataResponse<SecurityInfo[]>, undefined>().use(getForbiddenSecurities),
  set: createEffect<SecurityInfo[], SecurityInfo[], undefined>(),
};

sample({
  clock: forbiddenApi.get.done,
  target: helper.set,
});

sample({
  clock: forbiddenApi.set,
  target: helper.update,
});
